

export const isNotBlankObject = (item: any): boolean => {
    return Reflect.has(new Object(item), 0);
}